/**
 * True for local development and Covomo test/staging hosts.
 * Production hosts return false so features can stay gated there.
 */
export function isNonProductionEnvironment(): boolean {
  if (process.env.NODE_ENV === "development") {
    return true;
  }
  if (typeof window === "undefined") {
    return false;
  }
  const h = window.location.hostname.toLowerCase();
  if (h === "localhost" || h === "127.0.0.1" || h === "[::1]") {
    return true;
  }
  if (
    h.includes(".test.covomo-services.com") ||
    h.endsWith(".test.covomo.de")
  ) {
    return true;
  }
  return false;
}
